import { useState } from 'react';

interface ClinicalChartCardProps {
  title: string;
  children: React.ReactNode;
  collapsible?: boolean;
  defaultCollapsed?: boolean;
  highlight?: boolean;
}

export const ClinicalChartCard = ({ 
  title, 
  children, 
  collapsible = false,
  defaultCollapsed = false,
  highlight = false
}: ClinicalChartCardProps) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  const handleToggle = () => {
    if (collapsible) {
      setIsCollapsed(!isCollapsed);
    }
  };

  return (
    <div className={`rounded-xl border-2 overflow-hidden ${
      highlight 
        ? 'border-blue-200 bg-white shadow-md' 
        : 'border-slate-200 bg-white'
    }`}>
      <div 
        className={`flex items-center justify-between px-6 py-4 border-b-2 ${
          highlight
            ? 'bg-blue-50 border-blue-100'
            : 'border-slate-200'
        } ${
          collapsible ? 'cursor-pointer hover:bg-slate-50 transition-colors' : ''
        }`}
        onClick={handleToggle}
      >
        <div className="flex items-center gap-3">
          {highlight && (
            <span 
              className="material-symbols-outlined text-primary text-2xl"
              style={{ fontVariationSettings: '"FILL" 0, "wght" 400, "GRAD" 0, "opsz" 24' }}
            >
              print
            </span>
          )}
          <h2 className={`text-xl font-bold ${
            highlight 
              ? 'text-primary' 
              : 'text-[#101822]'
          }`}>{title}</h2>
        </div>
        {collapsible && (
          <button
            type="button"
            className="flex items-center justify-center w-8 h-8 rounded-full text-slate-600 hover:bg-slate-200 transition-colors"
            aria-label={isCollapsed ? 'Expandir' : 'Colapsar'}
          >
            <span 
              className={`material-symbols-outlined transform transition-transform duration-300 ease-in-out ${
                isCollapsed ? 'rotate-180' : ''
              }`}
              style={{ fontVariationSettings: '"FILL" 0, "wght" 300, "GRAD" 0, "opsz" 24' }}
            >
              expand_more
            </span>
          </button>
        )}
      </div>
      <div 
        className={`transition-all duration-300 ease-in-out overflow-hidden ${
          isCollapsed ? 'max-h-0 opacity-0' : 'max-h-[2000px] opacity-100'
        }`}
      >
        <div className="p-6">
          {children}
        </div>
      </div>
    </div>
  );
};
